import { render, staticRenderFns } from "./CustomAlerts.vue?vue&type=template&id=5317e68d&"
import script from "./CustomAlerts.vue?vue&type=script&lang=ts&"
export * from "./CustomAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports